import Modal from '@/components/ui/modals';
import { useTranslations, useLocale } from 'next-intl';
import { useState } from 'react';
import RabehForm from '@/components/product/rabeh/rabeh-form';
import RabehRedeem from '@/components/product/rabeh/rabeh-redeem';

const RabehLoyaltyModal = ({ setIsModalOpen }) => {
  const t = useTranslations('common');
  const locale = useLocale();

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  return (
    <Modal
      maxWidth='max-w-11/12 lg:max-w-2xl'
      isOpen={true}
      onClose={() => setIsModalOpen(false)}
      headerTitleClassName='max-lg:!p-2 !px-4 !py-3 max-lg:text-sm'
      title={!showSuccessModal && t('Join_Rabeh')}
      titleClassName='max-sm:text-xs max-sm:font-bold'
    >
      {showSuccessModal ? (
        <RabehRedeem {...{ t }} />
      ) : (
        <RabehForm {...{ t, locale, setShowSuccessModal, setIsModalOpen }} />
      )}
    </Modal>
  );
};

export default RabehLoyaltyModal;
